<template>
	<aside class="qly-aside" :class="{'qly-aside-iscoll':!isCollapse}">
		<el-menu :default-active="$router.currentRoute.path" class="el-menu-vertical-demo qly-menu" unique-opened router
			:collapse="isCollapse">
			<template v-for="item in menus">
				<el-submenu :key="item.name" :index="item.path" class="homeNav">
					<template slot="title">
						<i :class="item.meta.icon"></i>
						<span slot="title">
							<el-badge :value="item.meta.dotCount" :hidden="item.meta.dotCount > 0 ? false : true"
								class="item">
								{{ item.meta.title }}
							</el-badge>
						</span>
					</template>
					<el-menu-item v-for="child in item.children" :key="child.name" :index="child.path">
						<i :class="child.meta.icon"></i>
						<el-badge :value="child.meta.dotCount" class="item">
							{{ child.meta.title }}
						</el-badge>
					</el-menu-item>
				</el-submenu>
			</template>
		</el-menu>
	</aside>
</template>

<script>
	export default {
		props: {
			isCollapse: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				userinfo: {},
				menus: [],
				TodosData: [], //审核待办事项
				// isCollapse: true,
			};
		},
		mounted() {
			this.userinfo = JSON.parse(localStorage.getItem("userInfo"));
			this.getMenuData();
		},
		methods: {

			async getMenuData() {
				const res = await this.$Request(this.$Interface.GetUserMenus, {});
				if (res.code == 1) {
					let menuList = res.data;
					let data = menuList.filter((t) => t.isMenu == true); //查找菜单数据
					this.setPowerData(data);
					//按钮权限集合
					this.setBtnPermission(data);
				}
			},

			//按钮权限集合
			setBtnPermission(menuList) {
				var btnPermissionList = [];
				menuList.map(function(item) {
					if (item.menuPermissions != null && item.menuPermissions.length > 0) {
						let list = item.menuPermissions.split(',');
						list.map(function(citem) {
							btnPermissionList.push(citem);
						});
					}
				});
				localStorage.setItem("btnPermissionList", JSON.stringify(btnPermissionList));
			},

			//过滤所有权限的顺序为 管理员、always=true 》》权限筛选》》所属端
			setPowerData(menuList) {
				var that = this;
				//var routesdata = that.$router.options.routes; //权限列表
				var routesdata = JSON.parse(JSON.stringify(that.$router.options.routes)); //权限列表 阻止变量拷贝
				var routes = routesdata.filter((t) => t.children); //过滤无子数据的路由

				//使用forEach 过滤不是菜单的路由
				let newroutes = [];
				routes.forEach((now, index) => {
					newroutes[index] = now;
					newroutes[index].children = now.children.filter((item) => {
						return item.meta.isMenu === true;
					});
				});

				function isPower(d) {
					//管理员
					if (that.userinfo.isSuper == 1) {
						return true;
					}
					if (!d) {
						return false;
					}

					if (d.children && d.children.length > 0) {
						return true;
					}

					for (let i = 0; i < menuList.length; i++) {
						if (menuList[i].powerCode == d.power_code && d.meta.isMenu == true) {
							return true;
						}
					}

					return false;
				}

				//遍历每一条路径
				function CleanUp(d) {
					if (!d) {
						return [];
					}
					let r = [];
					for (let i = 0; i < d.length; i++) {
						if (isPower(d[i])) {
							let tmp = Object.assign({}, d[i]);
							tmp.children = CleanUp(tmp.children);
							if (!d[i].children) {
								r.push(tmp);
							} else if (tmp.children.length > 0) {
								r.push(tmp);
							}
						}
					}
					return r;
				}
				var data = CleanUp(newroutes);
				this.menus = data.filter((t) => t.meta != undefined);
			},
		},
	};
</script>

<style scoped lang="scss">
	.qly-aside {
		height: 100%;
		// width: 200px;
		// min-width: 202px;
		// color: white;
		// background-image: linear-gradient(to bottom right, #51b0ff, #2878ff);
		border-right: 1px solid #e6e6e6;
		overflow-x: hidden;
		overflow-y: auto;


		.qly-menu {
			height: 100%;
		}

		i {
			margin-right: 10px;
			font-size: 1.5rem;
		}

		.t-icon {
			display: inline-block;
			width: 26px !important;
			height: 26px !important;
		}
	}

	.qly-aside-iscoll {
		width: 200px;
		min-width: 202px;
		border-right: 0px solid #e6e6e6;
	}
</style>